import { render } from "./RetributionDetails.vue?vue&type=template&id=65ca2480"
import script from "./RetributionDetails.vue?vue&type=script&lang=js"
export * from "./RetributionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__